import * as React from 'react';
import './brushedLabel.module.scss';

export const BrushedLabel = ({ children, className = undefined, styleName = undefined }) => (
    <span styleName="brushed-label" className={className}>
        {children}
    </span>
);
